/**
 * SURVIVOR_BALANCE — single source of truth for all survivor-mode tunables.
 *
 * Object is intentionally MUTABLE so the dev-only Tweakpane panel can change
 * values at runtime without a reload. Consumers MUST read fields at call-time
 * (i.e. `SURVIVOR_BALANCE.x` inside a function body), never destructure at
 * import time, so live edits propagate immediately.
 *
 * Behavior is UNCHANGED from pre-refactor — every default here matches the
 * hardcoded constant it replaces.
 */
export const SURVIVOR_BALANCE = {
  /** Total sector timer (ms). Surviving this long opens the exit door. */
  sectorDurationMs: 60_000,

  /** Hard ceiling on concurrent live enemies (object-pool friendly). */
  spawnCapHard: 70,

  /** Baseline target-alive count at sector 1 (frac = 0). */
  spawnBase: 8,

  /** Additional base alive-count per sector level beyond 1. */
  spawnPerSector: 2,

  /**
   * End-of-sector ramp multiplier. Target = base * (1 + frac * spawnRampMult).
   * 1 → ~2× base at the end of a sector.
   */
  spawnRampMult: 1,

  /** Milliseconds between "top-up" refill checks in the spawn director. */
  spawnRefillIntervalMs: 250,

  /** Damage per second dealt to the cat while overlapping a hazard puddle. */
  hazardDps: 6,

  /** How long (ms) a hazard puddle lingers before despawning. */
  hazardDurationMs: 3500,

  /** XP threshold base for level 1: xpToNextLevel = xpBase + xpPerLevel * level. */
  xpBase: 5,

  /** XP threshold increment per level. */
  xpPerLevel: 4,

  /**
   * Default pickup radius (px) for XP gems and loot.
   * Individual runs may override via catStats.lootPickupRadius (perk-granted).
   */
  pickupRadius: 60,
};
